import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';

interface ITrackListingSwipeClose {
  jsonQuery: IJsonQuery;
  listingType: 'map' | 'listing';
}

export function trackListingSwipeClose({ jsonQuery, listingType }: ITrackListingSwipeClose) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'close_sopr',
    label: 'listing_swipe',
    page: {
      pageType: 'Listing',
      listingType,
    },
    sc: jsonQuery,
  });
}
